import { Component, Inject } from '@angular/core';
import { AppBasicEntity } from '@entity/app-basic.entity';
import { $app } from "@app/app.service";

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { HttpUserService } from '@app/data/service/http-user.service';
import { Store, select } from '@ngrx/store';
import * as StageActions from '@data/store/stage/stage.actions';
import { AppState } from '@data/store/storage.module';

@Component({
    selector: 'entity-dialog-privacy',
    templateUrl: './privacy-dialog.entity.html'
})
export class PrivacyDialogEntity extends AppBasicEntity {
    public acceptCheckbox = new FormControl(false);

    constructor(public dialogRef: MatDialogRef<PrivacyDialogEntity>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userService: HttpUserService,
        private store: Store) {
        super();
    }

    ngOnInit() {
        console.log('data', this.data)
        //this.log('DialogDeleteEntity - init:', this.data);

    }

    preferenceChange() {
        const id = $app.core.user.getId();
        this.userService.updatePrivacyStatementPreference(id, this.acceptCheckbox.value).subscribe({
            next: (res) => {
                console.log('res', res)
                this.store.dispatch(StageActions.setPrivacyStatement({ privacyStatement: this.acceptCheckbox.value }));
                this.dialogRef.close();
            },
            error: (err) => {
                this.store.dispatch(StageActions.setPrivacyStatement({ privacyStatement: this.acceptCheckbox.value }));
            }
        })
    }

    checkboxValidation(): boolean {
        return !this.acceptCheckbox.value
    }
}

